module.exports = __webpack_public_path__ + "img/hotsale.cb34925d.svg";